"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalHeader = void 0;
var modalHeader = {
  colors: {
    default: {
      borderColor: function borderColor(get) {
        return get('colorScheme', 'weakBorder');
      }
    }
  },
  padding: {
    default: '1rem'
  },
  border: function border(get) {
    return get('globals', 'border');
  },
  borderRadius: function borderRadius(get) {
    return get('globals', 'borderRadius');
  }
};
exports.modalHeader = modalHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-config/lib/theme/modalHeader.js
// module id = 1179
// module chunks = 0